document.addEventListener('DOMContentLoaded', function () {
  var rootList = document.querySelectorAll('[data-article-index-root]');

  function setIndexState(toc, toggle, body, expanded) {
    toc.classList.toggle('t4s-article-index--expanded', expanded);
    toc.classList.toggle('t4s-article-index--collapsed', !expanded);

    if (toggle) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var toggleText = toggle.querySelector('[data-article-index-toggle-text]');
      if (toggleText) {
        toggleText.textContent = expanded ? 'Ocultar' : 'Mostrar';
      }
    }

    if (body) {
      body.setAttribute('aria-hidden', expanded ? 'false' : 'true');
      body.style.maxHeight = expanded ? Math.max(body.scrollHeight, 120) + 'px' : '0px';
    }
  }

  rootList.forEach(function (root) {
    var list = root.querySelector('[data-article-index-list]');
    var articleContent = root.querySelector('[data-article-content]');
    var toc = root.querySelector('.t4s-article-index');
    var toggle = root.querySelector('[data-article-index-toggle]');
    var body = root.querySelector('[data-article-index-body]');

    if (!list || !articleContent || !toc) return;

    var headings = Array.from(articleContent.querySelectorAll('h2, h3'));

    list.innerHTML = '';

    if (!headings.length) {
      toc.classList.add('t4s-article-index--hidden');
      return;
    }

    var slugify = function (value) {
      return value
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
    };

    headings.forEach(function (heading, index) {
      var text = heading.textContent.trim();
      if (!text) return;

      var baseId = heading.id || 'article-heading-' + (index + 1) + '-' + slugify(text);
      var id = baseId;
      var counter = 1;

      while (document.getElementById(id) && document.getElementById(id) !== heading) {
        id = baseId + '-' + counter;
        counter += 1;
      }

      heading.id = id;

      var level = parseInt(heading.tagName.replace('H', ''), 10);
      var item = document.createElement('li');
      item.className = 't4s-article-index__item t4s-article-index__item--level-' + level;
      item.innerHTML = '<a href="#' + id + '">' + text + '</a>';
      list.appendChild(item);
    });

    toc.classList.remove('t4s-article-index--hidden');

    if (toggle && body) {
      setIndexState(toc, toggle, body, false);

      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        setIndexState(toc, toggle, body, !expanded);
      });
    }
  });
});
